import React from 'react';
import PropTypes from 'prop-types';
import { FormHelperText } from '@material-ui/core';

export default function FormErrorText(props) {
  const { error, children } = props;

  return (
    <FormHelperText error={error}>{children}</FormHelperText>
  );
}

FormErrorText.propTypes = {
  error: PropTypes.bool.isRequired,
  children: PropTypes.node,
};

FormErrorText.defaultProps = {
  children: null,
};
